import { createAction, props } from '@ngrx/store';

const prefix = '[unreadEvents]';

const setUnreadEvents = createAction(`${prefix} Set unreadEvents`, props<{ unreadEvents: number }>());

export const unreadEventsActions = {
    setUnreadEvents,
};
